import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_70: FaireProductEntity = {
  token: "starter_collection_70",
  type: "product",
  name: "Tailgate Dish Towels",
  brandName: "Atelier Saucier",
  imageUrl:
    "https://cdn.faire.com/fastly/74728c8fa220c655f59c59155bca2f64f60ffabf66d29326811bb8114fd64178.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 38,
  msrpDollars: 76,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
